import React, { Component } from 'react';
import { connect } from 'react-redux';
import FormModal from 'components/shared/modal/FormModal';
import './ChangeOrderModal.css';
import numeral from 'numeral';
import {
  getCurrentWorkOrder,
  getTasks,
} from 'selectors/admin/work-orders/work-orders';
import { getChangeOrderTasks } from 'components/admin/work-orders/details/change-order-tasks/store/selectors';
import { getQuotesSelectedByTaskId } from 'selectors/admin/work-orders/details/details';
import {
  getChangeOrders,
  getShowChangeOrderModal,
  getStartDate,
  getCompletionDate,
  getValuesByQuoteId,
  getCurrentView,
} from 'components/admin/work-orders/details/change-orders/store/selectors';
import {
  closeChangeOrderModal,
  continueRequest,
  next,
  back,
} from 'components/admin/work-orders/details/change-orders/store/actions';
import NewProposalForm from 'components/admin/work-orders/details/proposals/NewProposalForm';
import Button from 'components/shared/button/Button';
import { ProposalStatus } from 'domain/proposal-status-enum';
import TasksReviewTable from 'components/admin/work-orders/details/proposals/TasksReviewTable';
import CostsDatesProposal from 'components/admin/work-orders/details/proposals/CostsDatesProposal';
import ConfirmationPanel from 'components/shared/confirmation/ConfirmationPanel';
import checkCirclePng from 'images/check-circle.png';
import {
  getQualifications,
  getSelectedQualificationsById,
} from 'selectors/admin/work-orders/details/qualifications';
import QualificationsContainer from 'components/admin/work-orders/details/qualifications/QualificationsContainer';

class ChangeOrderModal extends Component {
  handleClose = () => {
    this.props.dispatch(closeChangeOrderModal());
  };

  handleBack = (event) => {
    event.preventDefault();
    this.props.dispatch(back(this.props.currentView));
  };

  handleButton = () => {
    if (this.props.currentView === 'review') {
      this.props.dispatch(
        continueRequest(
          this.props.currentWorkOrder.id,
          this.props.startDate,
          this.props.completionDate,
          this.props.valuesByQuoteId,
          this.props.qualifications,
          this.props.selectedQualificationsById
        )
      );
    } else {
      this.props.dispatch(next(this.props.currentView));
    }
  };

  createItems = () => {
    let items = [];
    Object.values(this.props.quotesSelectedByTaskId).forEach(
      (changeOrderTaskId) => {
        const changeOrderTask = this.props.changeOrderTasks.find(
          (cot) => cot.id === changeOrderTaskId
        );
        const task = this.props.tasks.find(
          (t) => t.id === changeOrderTask.task_id
        );
        const changeOrderQuote = changeOrderTask.change_order_quote;

        items.push({
          id: changeOrderTaskId,
          amount: changeOrderQuote.estimate,
          value: changeOrderQuote.value,
          contractorName: task.contractor_name,
          task: task,
          values: this.props.valuesByQuoteId[changeOrderTaskId],
        });
      }
    );

    return items;
  };

  handleThankYou = () => {
    this.props.dispatch(closeChangeOrderModal());
  };

  previousCost = () => {
    let prevCost = numeral(
      this.props.currentWorkOrder.approved_proposal.cost
    ).value();
    this.props.changeOrders
      .filter((co) => ProposalStatus.APPROVED.equals(co.status))
      .forEach(function (co) {
        prevCost += numeral(co.cost).value();
      });

    return prevCost;
  };

  static getWorkOrderName(workOrder) {
    return workOrder.name !== null ? `: ${workOrder.name}` : '';
  }

  render() {
    const couldGoBack = this.props.currentView === 'review';
    let title;
    const postTitle = `Change Order (WO #${
      this.props.currentWorkOrder.number
    }${ChangeOrderModal.getWorkOrderName(this.props.currentWorkOrder)})`;

    let mainComponent;
    switch (this.props.currentView) {
      case 'form':
        mainComponent = this.renderForm();
        title = postTitle;
        break;
      case 'review':
        mainComponent = this.renderReview();
        title = postTitle;
        break;
      case 'thank-you':
        mainComponent = this.renderThankYou();
        break;
      default:
        mainComponent = null;
    }

    return this.props.show ? (
      <FormModal
        className="change-order-modal"
        show={this.props.show}
        showHeader={this.props.currentView !== 'thank-you'}
        title={title}
        onBack={couldGoBack ? this.handleBack : undefined}
        onClose={this.handleClose}
      >
        {mainComponent}
      </FormModal>
    ) : null;
  }

  renderForm = () => {
    let items = this.createItems();
    return (
      <div className="quotes-container">
        <NewProposalForm
          startDate={this.props.startDate}
          completionDate={this.props.completionDate}
          items={items}
          isChangeOrder={true}
          previousCost={this.previousCost()}
        />

        <QualificationsContainer />

        <div className="button-container">
          <Button
            className="button-orange"
            disabled={!this.isReviewButtonEnable()}
            label="Review"
            onClick={this.handleButton}
          />
        </div>
      </div>
    );
  };

  renderReview() {
    let quotesTotal = 0;
    let valuesTotal = Object.values(this.props.valuesByQuoteId).reduce(
      (accumulator, currentValue) => {
        return (
          accumulator +
          currentValue['markup'] +
          currentValue['fee'] +
          currentValue['insurance']
        );
      },
      0
    );

    const values = [];
    Object.values(this.props.quotesSelectedByTaskId).forEach(
      (changeOrderTaskId) => {
        const changeOrderTask = this.props.changeOrderTasks.find(
          (cot) => cot.id === changeOrderTaskId
        );
        const task = this.props.tasks.find(
          (t) => t.id === changeOrderTask.task_id
        );
        const changeOrderQuote = changeOrderTask.change_order_quote;

        quotesTotal =
          quotesTotal +
          numeral(changeOrderQuote.estimate).value() +
          numeral(changeOrderQuote.value).value();
        const quoteValues = this.props.valuesByQuoteId[changeOrderTaskId];
        const quoteTotal =
          numeral(changeOrderQuote.estimate).value() +
          numeral(changeOrderQuote.value).value() +
          numeral(quoteValues['markup']).value() +
          numeral(quoteValues['fee']).value() +
          numeral(quoteValues['insurance']).value();

        values.push({
          id: task.id,
          number: task.number,
          details: task.name !== null ? task.name : task.trade.label,
          materialLeadTime: this.getMaterialLeadTime(
            changeOrderQuote.material_lead_days
          ),
          contractor: task.contractor_name,
          cost: quoteTotal,
        });
      }
    );

    return (
      <div className="quotes-container">
        <TasksReviewTable showContractor={true} values={values} />

        <div className="costs-dates-container">
          <CostsDatesProposal
            completionDate={{
              editable: true,
              value: this.props.completionDate,
            }}
            startDate={this.props.startDate}
            total={quotesTotal + valuesTotal}
            isChangeOrder={true}
            previousCost={this.previousCost()}
          />
        </div>

        <QualificationsContainer readOnly={true} />

        <div className="button-container">
          <Button
            className="button-orange"
            label="Send"
            onClick={this.handleButton}
          />
        </div>
      </div>
    );
  }

  renderThankYou() {
    return (
      <ConfirmationPanel
        image={checkCirclePng}
        firstLine="Thank you!"
        lines={[
          `Change Order for WO #${this.props.currentWorkOrder.number} has been sent to ${this.props.currentWorkOrder.client.company_name}.`,
        ]}
        buttons={[
          <input
            type="button"
            className="btn button button-orange"
            value="Continue"
            onClick={this.handleThankYou}
          />,
        ]}
      />
    );
  }

  getMaterialLeadTime(mDays) {
    if (mDays) {
      return `${numeral(mDays).value()} ${mDays > 1 ? 'days' : 'day'}`;
    }

    return 'N/A';
  }

  isReviewButtonEnable() {
    let optionUndefinedForQualification = false;
    Object.keys(this.props.selectedQualificationsById).forEach((key) => {
      const qualification = this.props.qualifications.find(
        (qualification) => qualification.id === numeral(key).value()
      ); // object.keys returns string
      if (qualification !== undefined && qualification.options.length > 0) {
        optionUndefinedForQualification =
          optionUndefinedForQualification ||
          this.props.selectedQualificationsById[key].option === null;
      }
    });
    return (
      this.props.startDate !== null &&
      this.props.completionDate !== null &&
      !optionUndefinedForQualification
    );
  }
}

export default connect((state) => {
  return {
    show: getShowChangeOrderModal(state),
    currentWorkOrder: getCurrentWorkOrder(state),
    tasks: getTasks(state),
    qualifications: getQualifications(state),
    changeOrders: getChangeOrders(state),
    changeOrderTasks: getChangeOrderTasks(state),
    quotesSelectedByTaskId: getQuotesSelectedByTaskId(state),
    selectedQualificationsById: getSelectedQualificationsById(state),
    startDate: getStartDate(state),
    completionDate: getCompletionDate(state),
    valuesByQuoteId: getValuesByQuoteId(state),
    currentView: getCurrentView(state),
  };
})(ChangeOrderModal);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/change-orders/ChangeOrderModal.js